module.exports = __webpack_public_path__ + "static/nxrt-automotive6-5eedb5bdc6c8d48f607a2b732bdcafec.jpg";